import {
  Bold,
  Code,
  Heading1,
  Heading2,
  Heading3,
  Italic,
  Link,
  List,
  ListOrdered,
  ListTodo,
  TextQuote,
} from 'lucide-react';

import { Button } from 'components/ui/button';
import type { EditorCommands } from './markdown-editor';

const tools = [
  {
    id: 1,
    children: [
      { id: 'h1', label: 'H1', icon: Heading1, onClick: (commands: EditorCommands) => commands.h1() },
      { id: 'h2', label: 'H2', icon: Heading2, onClick: (commands: EditorCommands) => commands.h2() },
      { id: 'h3', label: 'H3', icon: Heading3, onClick: (commands: EditorCommands) => commands.h3() },
    ],
  },
  {
    id: 2,
    children: [
      { id: 'bold', label: 'Bold', icon: Bold, onClick: (commands: EditorCommands) => commands.bold() },
      { id: 'italic', label: 'Italic', icon: Italic, onClick: (commands: EditorCommands) => commands.italic() },
    ],
  },
  {
    id: 3,
    children: [
      { id: 'unordered', label: 'Unordered List', icon: List, onClick: (commands: EditorCommands) => commands.unordered() },
      { id: 'ordered', label: 'Ordered List', icon: ListOrdered, onClick: (commands: EditorCommands) => commands.ordered() },
      { id: 'task', label: 'Task List', icon: ListTodo, onClick: (commands: EditorCommands) => commands.task() },
    ],
  },
  {
    id: 4,
    children: [
      { id: 'quote', label: 'Quote', icon: TextQuote, onClick: (commands: EditorCommands) => commands.quote() },
      { id: 'code', label: 'Code', icon: Code, onClick: (commands: EditorCommands) => commands.code() },
      { id: 'link', label: 'Link', icon: Link, onClick: (commands: EditorCommands) => commands.link() },
    ],
  },
];

type MarkdownEditorToolbarProps = {
  commands: EditorCommands;
  disabled?: boolean;
};

export const MarkdownEditorToolbar = ({ commands, disabled }: MarkdownEditorToolbarProps) => {
  return (
    <>
      {tools.map((group) => (
        <div key={group.id} className="flex overflow-hidden rounded-md border bg-background shadow-sm">
          {group.children.map((tool) => {
            const Icon = tool.icon;
            const isHeading = tool.id === 'h1' || tool.id === 'h2' || tool.id === 'h3';
            return (
              <Button
                type="button"
                key={tool.id}
                onClick={(event) => {
                  event.stopPropagation();
                  tool.onClick(commands);
                }}
                disabled={disabled}
                variant="outline"
                className="h-9 min-w-12 rounded-none border-0 border-r px-3 text-xs font-medium shadow-none last:border-r-0 hover:bg-accent/60"
                title={tool.label}
              >
                {isHeading ? <span className="font-semibold">{tool.label}</span> : <Icon className="h-4 w-4" />}
              </Button>
            );
          })}
        </div>
      ))}
    </>
  );
};
